import React from 'react';
import { FieldType } from './types';
import renderCompositeCell from './renderCompositeCell'; 
import FloatingTooltip from '#/components/FloatingTooltip/index';
import styles from './styles.module.css';


function renderCell(item, column, exhibition, index) {
  const value = item[column.key];

  switch (column.type) {
    case FieldType.COMPOSITE:
      if (!value || !column.fields) return null;
      return renderCompositeCell({ baseObject: value, column, index, exhibition });

      case FieldType.DATE: {
        const formattedValue = value ? new Date(value).toLocaleDateString('pt-BR') : '';
        return (
          <FloatingTooltip content={formattedValue}>
            <span className={styles.spanEllipsis}>{formattedValue}</span>
          </FloatingTooltip>
        );
      }
  
      default: {
        const text = value || ''; 
        return (
          <span className={styles.spanEllipsis}>
          <FloatingTooltip content={text}>
            <span className={styles.spanEllipsis}>{text}</span>
          </FloatingTooltip>
        </span>
        );
      }
  }
}

export default renderCell